import { SamplePack } from '@arpeggi/shared'
import { Box, theme } from '@arpeggi/ui'
import { FC } from 'react'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { useSamplePackRemixers } from '../../../__legacy__/queries/samplePacks'
import { useColorThief } from '../hooks'
import { Card, Collaborators, Details, Section } from '../primitives'

export const SPDetailsTabContent: FC<{ sp: SamplePack }> = ({ sp }) => {
  const remixersPerPage = 25
  const { palette } = useColorThief(sp.coverImage.url)
  const color = palette ? palette[1] : theme.colors.blackA100.value
  const samplePackRemixers = useSamplePackRemixers({
    id: sp.id,
    params: { perPage: remixersPerPage }
  })
  const { walletAddress, profilePicture, displayName } = sp.user
  const flattenedSamplePackRemixers =
    samplePackRemixers.data?.pages.flatMap((page) => page.data.map((user) => user)) || []

  return (
    <Tabs.Content value="#details">
      <Section.Root>
        <Section.Flare1 css={{ color }} />
        <Section.Flare2 css={{ color }} />
        <Section.Content>
          <Details.Root>
            <Card.Root css={{ minHeight: '300px' }}>
              <Card.Content>
                <Card.Text title>Pack users</Card.Text>
                <Collaborators.Root>
                  <Collaborators.Header>
                    <Collaborators.Link
                      noOverflow
                      href={`/profile/${walletAddress}`}
                      target="_blank"
                    >
                      <Collaborators.Avatar src={profilePicture?.url} />
                      <Collaborators.Title big>{displayName}</Collaborators.Title>
                      <Collaborators.Title big success>
                        Pack Creator
                      </Collaborators.Title>
                    </Collaborators.Link>
                  </Collaborators.Header>
                  {samplePackRemixers.isLoading && (
                    <Box row alignCenter justifyCenter>
                      <Details.Spinner />
                    </Box>
                  )}
                  {!samplePackRemixers.isLoading && (
                    <Collaborators.InfiniteScroll
                      hasMore={samplePackRemixers.hasNextPage}
                      next={samplePackRemixers.fetchNextPage}
                      dataLength={samplePackRemixers.data.pages.length * remixersPerPage}
                      loader={
                        <Box column alignCenter justifyCenter width="full">
                          <Details.Spinner />
                        </Box>
                      }
                    >
                      {flattenedSamplePackRemixers.map((user) => (
                        <Collaborators.Link
                          key={user.walletAddress}
                          href={`/profile/${user.walletAddress}`}
                          target="_blank"
                        >
                          <Collaborators.Avatar src={user.profilePicture?.url} />
                          <Collaborators.Title>{user.displayName}</Collaborators.Title>
                        </Collaborators.Link>
                      ))}
                    </Collaborators.InfiniteScroll>
                  )}
                </Collaborators.Root>
              </Card.Content>
            </Card.Root>
          </Details.Root>
        </Section.Content>
      </Section.Root>
    </Tabs.Content>
  )
}
